import { SECONDARY_TAGS_V2_DWEB } from 'constants/experiments';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { useSelector } from 'react-redux';
import { State } from 'store/types';

export const useIsTagsV2Enabled = () => {
  const tagsV2Enabled = useSelector((state: State) =>
    getEligibleForVariant(state, SECONDARY_TAGS_V2_DWEB, 'A')
  );
  return tagsV2Enabled;
};
